import { useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import MobileMenu from './MobileMenu.jsx'

export default function SiteHeader() {
  const { pathname } = useLocation()
  const isHome = pathname === '/'
  const [hidden, setHidden] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const lastScrollY = useRef(0)

  useEffect(() => {
    function handleScroll() {
      const currentScrollY = Math.max(window.scrollY, 0)
      const change = currentScrollY - lastScrollY.current

      setScrolled(currentScrollY > 16)

      if (menuOpen || currentScrollY < 88) {
        setHidden(false)
      } else if (change > 7) {
        setHidden(true)
      } else if (change < -7) {
        setHidden(false)
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [menuOpen])

  useEffect(() => {
    document.documentElement.classList.toggle('menu-open', menuOpen)

    if (!menuOpen) return undefined

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setMenuOpen(false)
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.documentElement.classList.remove('menu-open')
    }
  }, [menuOpen])

  function toggleMenu() {
    setHidden(false)
    setMenuOpen((current) => !current)
  }

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header
        className={`site-header${hidden ? ' is-hidden' : ''}${scrolled ? ' is-scrolled' : ''}`}
      >
        <nav className="nav-shell" aria-label="Primary navigation">
          <Link className="brand" to="/" aria-label="Zpace Studio home">
            <img src="/icon.png" alt="" width="36" height="36" />
            <span>Zpace Studio</span>
          </Link>
          <div className="nav-links">
            {isHome ? <a href="#explore">Explore</a> : <NavLink to="/">Home</NavLink>}
            <NavLink className="nav-about" to="/about/">
              About
            </NavLink>
            <NavLink to="/privacy/">Privacy</NavLink>
            <a className="nav-member" href="https://accounts.zpacestudio.com/">
              Dashboard
            </a>
          </div>
          <button
            className={`menu-toggle${menuOpen ? ' is-open' : ''}`}
            type="button"
            aria-controls="mobile-menu"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            onClick={toggleMenu}
          >
            <svg viewBox="0 0 20 20" aria-hidden="true">
              <line className="menu-toggle__line menu-toggle__line--top" x1="3" y1="7" x2="17" y2="7" />
              <line className="menu-toggle__line menu-toggle__line--bottom" x1="3" y1="13" x2="17" y2="13" />
            </svg>
          </button>
        </nav>
      </header>
      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  )
}
